var React = require('react');

function IcAwsCli (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"className":"st0","d":"M18.923,27.934h11.704v-2.118H18.922v2.118H18.923z M5.229,4.501H3.044v1.058h2.185V4.501z M8.375,4.501H6.19\n\t\tv1.058h2.185V4.501z M11.521,4.501H9.336v1.058h2.185V4.501z M9.004,30.884l8.679-8.679l-8.679-8.679l-1.497,1.497l7.182,7.182\n\t\tl-7.182,7.182L9.004,30.884z M0,0.983v38.034h24.288v-2.118H2.118V9.181h35.766v27.719h-4.149v2.118H40V0.983H0z M37.885,7.063\n\t\tH2.119V3.099h35.766V7.063z"})));
}

IcAwsCli.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 40 40","style":{"enableBackground":"new 0 0 40 40"},"xmlSpace":"preserve"};

module.exports = IcAwsCli;

IcAwsCli.default = IcAwsCli;
